import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Product from '@/views/Product';
import Clients from '@/views/Clients';
import About from '@/views/About-us';
import Contact from '@/views/Contact';
import Demo from '@/views/Demo';
import DemoAangevraagd from '@/views/demo-aangevraagd';
import Webinar from '@/views/Webinar';
import Blog from '@/views/Blog';
import Helpdesk from '@/views/Helpdesk';
import Voorwaarden from '@/views/Voorwaarden';
import Privacy from '@/views/Privacy';
import Norschoten from '@/views/Norschoten';
import Noorderbreedte from '@/views/Noorderbreedte';
import Zinzia from '@/views/Zinzia';
import Article9 from '@/views/anders-denken-anders-doen';
import Article8 from '@/views/een-efficiënte-planning-levert-geld-op';
import Article7 from '@/views/de-MSR-en-de-GRZ-zijn-gewoon-gelijk';
import Article6 from '@/views/wat-als-de-schaakcomputer-de-behandeling-gaat-inplannen';




Vue.use(Router)

// const LAYOUT_NO_HEADER = "no-header";
// const LAYOUT_NO_HEADER_FOOTER = "no-header-footer";

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/clients',
      name: 'clients',
      component: Clients
    },
    {
      path: '/about-us',
      name: 'about-us',
      component: About
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/demo',
      name: 'demo',
      component: Demo
    },

    {
      path: '/demo-aangevraagd',
      name: 'demo-aangevraagd',
      component: DemoAangevraagd
    },

    {
      path: '/webinar',
      name: 'webinar',
      component: Webinar
    },
    {
      path: '/blog',
      name: 'blog',
      component: Blog
    },
    {
      path: '/helpdesk',
      name: 'helpdesk',
      component: Helpdesk
    },
    {
      path: '/voorwaarden',
      name: 'voorwaarden',
      component: Voorwaarden
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/norschoten',
      name: 'norschoten',
      component: Norschoten
    },
    {
      path: '/noorderbreedte',
      name: 'noorderbreedte',
      component: Noorderbreedte
    },
    {
      path: '/zinzia',
      name: 'zinzia',
      component: Zinzia
    },
    {
      path: '/anders-denken-anders-doen',
      name: 'anders-denken-anders-doen',
      component: Article9
    },

    {
      path: '/een-efficiënte-planning-levert-geld-op',
      name: 'een-efficiënte-planning-levert-geld-op',
      component: Article8
    },

    {
      path: '/de-MSR-en-de-GRZ-zijn-gewoon-gelijk',
      name: 'de-MSR-en-de-GRZ-zijn-gewoon-gelijk',
      component: Article7
    },

    {
      path: '/wat-als-de-schaakcomputer-de-behandeling-gaat-inplannen',
      name: 'wat-als-de-schaakcomputer-de-behandeling-gaat-inplannen',
      component: Article6
    },



  ]
})



